(() => {
  if (document.documentElement.hasAttribute('data-lx-sticky-initialized')) return;
  document.documentElement.setAttribute('data-lx-sticky-initialized', '');
  const initialize = (scope = document) => {
    const nav = scope.querySelector('.lx-mobile-nav');
    if (!nav || nav.hasAttribute('data-rewards-ready')) return;
    const bar = nav.closest('.mobile-sticky-bar');
    const rewards = nav.querySelector('[data-lx-nav-rewards]');
    if (!bar || !rewards) return;
    const controller = new AbortController(), options = { signal: controller.signal };
    const mobile = window.matchMedia('(max-width:749px)');
    const category = nav.querySelector('[data-lx-category-trigger]');
    const sheet = bar.querySelector('[data-lx-category-sheet]');
    const backdrop = bar.querySelector('[data-lx-category-backdrop]');
    const closeButton = bar.querySelector('[data-lx-category-close]');
    let categoryOpen = false, categoryScroll, bodyStyles, inertNodes = [];
    const closeCategory = (restoreFocus = true) => {
      if (!categoryOpen) return;
      categoryOpen = false;
      sheet.hidden = true; backdrop.hidden = true;
      category.setAttribute('aria-expanded', 'false');
      bar.removeAttribute('role'); bar.removeAttribute('aria-modal'); bar.removeAttribute('aria-labelledby');
      document.body.classList.remove('lx-category-open');
      inertNodes.forEach(node => { node.inert = false; }); inertNodes = [];
      for (const [property, value, priority] of bodyStyles) {
        if (value) document.body.style.setProperty(property, value, priority);
        else document.body.style.removeProperty(property);
      }
      window.scrollTo({ left: categoryScroll.x, top: categoryScroll.y, behavior: 'instant' });
      if (restoreFocus && category.isConnected) category.focus({ preventScroll: true });
    };
    const openCategory = () => {
      if (!mobile.matches || !sheet || categoryOpen) return;
      categoryOpen = true;
      categoryScroll = { x: window.scrollX, y: window.scrollY };
      bodyStyles = ['position', 'top', 'left', 'width', 'overflow'].map(property => [property, document.body.style.getPropertyValue(property), document.body.style.getPropertyPriority(property)]);
      document.body.style.position = 'fixed'; document.body.style.top = -categoryScroll.y + 'px'; document.body.style.left = -categoryScroll.x + 'px'; document.body.style.width = '100%'; document.body.style.overflow = 'hidden';
      document.body.classList.add('lx-category-open');
      sheet.hidden = false; backdrop.hidden = false;
      bar.setAttribute('role', 'dialog'); bar.setAttribute('aria-modal', 'true'); bar.setAttribute('aria-labelledby', sheet.querySelector('h2').id);
      category.setAttribute('aria-expanded', 'true');
      // Keep the five navigation actions inside the modal; isolate the page behind it.
      for (let branch = bar; branch && branch !== document.body; branch = branch.parentElement) {
        for (const sibling of branch.parentElement.children) {
          if (sibling !== branch && !sibling.inert && !['SCRIPT','STYLE','LINK'].includes(sibling.tagName)) { sibling.inert = true; inertNodes.push(sibling); }
        }
      }
      closeButton.focus({ preventScroll: true });
    };
    if (category && sheet && backdrop && closeButton) {
      category.setAttribute('role', 'button');
      category.addEventListener('click', event => { if (!mobile.matches) return; event.preventDefault(); categoryOpen ? closeCategory() : openCategory(); }, options);
      category.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); category.click(); } }, options);
      closeButton.addEventListener('click', () => closeCategory(), options);
      backdrop.addEventListener('click', () => closeCategory(), options);
      bar.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (categoryOpen && link && link !== category) closeCategory(false);
      }, { ...options, capture: true });
      document.addEventListener('keydown', event => {
        if (!categoryOpen) return;
        if (event.key === 'Escape') { event.preventDefault(); closeCategory(); return; }
        if (event.key !== 'Tab') return;
        const targets = [...bar.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex="0"]')].filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
        const first = targets[0], last = targets[targets.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, options);
      mobile.addEventListener('change', () => { if (!mobile.matches) closeCategory(false); }, options);
      window.addEventListener('pagehide', () => closeCategory(false), options);
    }
    const status = nav.querySelector('[data-lx-nav-status]');
    const original = rewards.querySelector('.lx-nav-label').textContent;
    let timer, frame, pending = false, sent = false, pass = false, deadline = 0, panelObserver;
    const size = () => {
      const height = mobile.matches ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--lx-measured-nav-height', height + 'px');
      document.documentElement.style.setProperty('--sticky-bar-height', height + 'px');
    };
    const resize = new ResizeObserver(size);
    resize.observe(bar);
    const keyboard = () => {
      const editing = Boolean(document.activeElement?.matches('textarea,input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]),select'));
      nav.toggleAttribute('data-keyboard', mobile.matches && editing);
    };
    const queueKeyboard = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(keyboard);
    };
    const finish = (retry = false) => {
      clearTimeout(timer);
      pending = false;
      rewards.removeAttribute('aria-busy');
      status.textContent = retry ? original + ': ' + rewards.dataset.retry : '';
    };
    const observeClose = panel => {
      panelObserver?.disconnect();
      panelObserver = new MutationObserver(() => {
        if (panel.isConnected && panel.getBoundingClientRect().height) return;
        panelObserver.disconnect();
        if (!document.hidden && mobile.matches) rewards.focus({ preventScroll: true });
      });
      if (panel.parentElement?.parentElement) panelObserver.observe(panel.parentElement.parentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    };
    const attempt = () => {
      if (!pending) return;
      if (document.hidden) { finish(); return; }
      if (performance.now() > deadline) { finish(true); return; }
      const panel = document.querySelector('.smile-panel-frame');
      if (panel?.getBoundingClientRect().height) { finish(); observeClose(panel); return; }
      if (!sent && document.querySelector('#smile-lite-launcher-frame,.smile-launcher-frame')) {
        sent = true; pass = true;
        try { rewards.click(); } finally { pass = false; }
      }
      if (pending) timer = setTimeout(attempt, 100);
    };
    rewards.addEventListener('click', event => {
      if (pass) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (pending) return;
      pending = true; sent = false; deadline = performance.now() + 15000;
      rewards.setAttribute('aria-busy', 'true');
      status.textContent = original + ': ' + rewards.dataset.opening;
      attempt();
    }, options);
    rewards.addEventListener('keydown', event => {
      if (event.key === ' ') { event.preventDefault(); rewards.click(); }
    }, options);
    const openCart = event => {
      const link = event.target.closest('#cart-icon-bubble-sticky');
      if (!link || nav.dataset.cartDrawer !== 'drawer' || link.getAttribute('aria-current') === 'page') return;
      if (event.type === 'keydown' && event.key !== ' ') return;
      const drawer = document.querySelector('cart-drawer');
      if (typeof drawer?.open !== 'function') return;
      event.preventDefault(); event.stopImmediatePropagation(); drawer.open(link);
    };
    nav.addEventListener('click', openCart, { ...options, capture: true });
    nav.addEventListener('keydown', openCart, { ...options, capture: true });
    const syncCount = data => {
      const source = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      const badge = nav.querySelector('[data-lx-nav-count]');
      const label = nav.querySelector('[data-lx-nav-count-label]');
      if (!badge) return;
      const total = data?.cartData?.item_count;
      if (Number.isInteger(total) && total >= 0) {
        badge.textContent = total > 999 ? '999+' : String(total);
        badge.hidden = total === 0;
        if (label) label.textContent = total ? total + ' ' + nav.querySelector('#cart-icon-bubble-sticky .lx-nav-label').textContent : '';
        return;
      }
      if (!document.getElementById('cart-icon-bubble')) return;
      const count = source?.querySelector('[aria-hidden="true"]')?.textContent.trim() || (source ? '999+' : '0');
      badge.textContent = count;
      badge.hidden = !source;
      if (label && source) label.textContent = source.querySelector('.visually-hidden')?.textContent || '';
      if (label && !source) label.textContent = '';
    };
    const countObserver = new MutationObserver(syncCount);
    const headerCart = document.getElementById('cart-icon-bubble');
    if (headerCart) countObserver.observe(headerCart, { childList: true, subtree: true, characterData: true });
    const unsubscribe = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
      ? subscribe(PUB_SUB_EVENTS.cartUpdate, syncCount) : null;
    document.addEventListener('focusin', keyboard, options);
    document.addEventListener('focusout', queueKeyboard, options);
    document.addEventListener('visibilitychange', () => { if (document.hidden) finish(); }, options);
    window.addEventListener('pagehide', () => finish(), options);
    window.addEventListener('pageshow', () => { size(); keyboard(); }, options);
    mobile.addEventListener('change', () => { size(); keyboard(); }, options);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target !== bar && !event.target.contains(nav)) return;
      closeCategory(false); category?.removeAttribute('role');
      finish(); resize.disconnect(); countObserver.disconnect(); panelObserver?.disconnect();
      unsubscribe?.(); controller.abort(); cancelAnimationFrame(frame);
      nav.removeAttribute('data-rewards-ready');
      document.documentElement.style.removeProperty('--lx-measured-nav-height');
      document.documentElement.style.removeProperty('--sticky-bar-height');
    }, options);
    nav.setAttribute('data-rewards-ready', '');
    size(); keyboard(); syncCount();
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
